export const mcDefaultColours = [
    {
        name: 'Black',
        colour: '#000000',
        code: '&0'
    },
    {
        name: 'Dark Blue',
        colour: '#0000AA',
        code: '&1'
    },
    {
        name: 'Dark Green',
        colour: '#00AA00',
        code: '&2'
    },
    {
        name: 'Dark Aqua',
        colour: '#00AAAA',
        code: '&3'
    },
    {
        name: 'Dark Red',
        colour: '#AA0000',
        code: '&4'
    },
    {
        name: 'Dark Purple',
        colour: '#AA00AA',
        code: '&5'
    },
    {
        name: 'Gold',
        colour: '#FFAA00',
        code: '&6'
    },
    {
        name: 'Grey',
        colour: '#AAAAAA',
        code: '&7'
    },
    {
        name: 'Dark Grey',
        colour: '#555555',
        code: '&8'
    },
    {
        name: 'Blue',
        colour: '#5555FF',
        code: '&9'
    },
    {
        name: 'Green',
        colour: '#55FF55',
        code: '&a'
    },
    {
        name: 'Aqua',
        colour: '#55FFFF',
        code: '&b'
    },
    {
        name: 'Red',
        colour: '#FF5555',
        code: '&c'
    },
    {
        name: 'Light Purple',
        colour: '#FF55FF',
        code: '&d'
    },
    {
        name: 'Yellow',
        colour: '#FFFF55',
        code: '&e'
    },
    {
        name: 'White',
        colour: '#FFFFFF',
        code: '&f'
    },
];
